import { useParams } from "react-router-dom";
import { SETTINGS_ITEMS, stepLabel } from "@/constants/settingsItems";

export default function SettingSubpage() {
  const { slug } = useParams();
  const index = SETTINGS_ITEMS.findIndex((s) => s.slug === slug);
  const item = SETTINGS_ITEMS[index];

  if (!item) {
    return (
      <div className="py-10 text-center text-slate-400" data-testid="setting-not-found">
        Setting not found.
      </div>
    );
  }

  return (
    <div className="py-6" data-testid={`setting-subpage-${slug}`}>
      <div className="mb-2">
        <span className="text-sm font-bold underline underline-offset-2 text-[#13B5EA]">
          {stepLabel(index)}
        </span>
      </div>
      <h2 className="text-2xl italic font-semibold text-[#1e2d38]">{item.label}</h2>
      <p className="mt-4 text-slate-400">
        This section will be designed next.
      </p>
    </div>
  );
}
